<template>
  <div class="bg-white rounded-lg m-3">
    <transition name="fade">
      <div
        v-if="get_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ get_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="edit_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ edit_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="delete_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ delete_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="create_error"
        class="p-1 text-center text-sm w-full bg-green-200"
      >
        {{ create_error }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="create_success"
        class="p-1 text-center text-sm w-full bg-green-200"
      >
        {{ create_success }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="edit_success"
        class="p-1 text-center text-sm w-full bg-green-200"
      >
        {{ edit_success }}
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="delete_success"
        class="p-1 text-center text-sm w-full bg-green-200"
      >
        {{ delete_success }}
      </div>
    </transition>

    <div class="py-5">
      <label class="block pb-3">Assign Claim Workflow</label>
      <div
        v-if="organizationClaimWorkflows.length > 0"
        class="grid lg:grid-cols-4 justify-start gap-y-4 w-3/4 text-sm"
      >
        <div
          v-for="claimType in organizationClaimWorkflows"
          :key="claimType.ClaimWorkflowHeaderId"
        >
          <label
            :for="claimType.ClaimWorkflowHeaderId"
            class="font-bold mb-2 cursor-pointer"
          >
            <input
              type="checkbox"
              class="cursor-pointer"
              :id="claimType.ClaimWorkflowHeaderId"
              @change="(isChecked) => assignEmployee(isChecked, claimType)"
              :checked="isAssigned(claimType.ClaimWorkflowHeaderId)"
            />

            {{ claimType.Name }}
          </label>
        </div>
      </div>
      <p class="text-center p-2" v-else>No Claims Workflows</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "claimManagement",
  props: ["title", "data"],
  data() {
    return {
      edit_error: null,
      create_success: null,
      create_error: null,
      get_error: null,
      delete_error: null,
      delete_success: null,
      edit_success: null,
      organizationClaimWorkflows: [],
      myClaimWorkflows: [],
      claimWorkflows: [],
      selectedClaimWorkflow: null,
    };
  },

  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getTabTitle",
      "getCurrentEmployeeId",
    ]),
  },

  methods: {
    isAssigned(claimTypeId) {
      return [this.myClaimWorkflows].some(
        (claim) => claim.ClaimWorkflow && claim.ClaimWorkflowId === claimTypeId
      );
    },
    // /{organization}/setup/claim/workflow/v1/request
    getClaimWorkflows() {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(`${this.getOrganization}/setup/claim/workflow/v1/request`, options)
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode === 200) {
              this.claimWorkflows = response.data.Data.filter(
                (workflow) => workflow.Name !== "Test Workflow"
              );
              //console.log(this.claimWorkflows);
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
            setTimeout(() => {
              this.get_error = null;
            }, 2500);
          }
        );
    },
    // /{organization}/setup/claim/workflow/v1/request
    getLeaveTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/claim/workflow/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode === 200) {
              this.get_success = response.data.StatusMessage;
              this.organizationClaimWorkflows = response.data.Data;
              //console.log(this.organizationClaimWorkflows);
              this.loading = false;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
            setTimeout(() => {
              this.showEditError = false;
            }, 2000);
          }
        );
    },

    // /{organization}/employee/claim/workflow/v1/assign
    assignEmployee(isChecked, claim) {
      // if (!isChecked.target.checked) {
      //   this.deleteClaimWorkflowAssignedToEmployee(claim.ClaimWorkflowHeaderId);
      //   return;
      // }
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      const data = {
        EmployeeId: this.getCurrentEmployeeId,
        ClaimWorkflowId: claim.Id,
      };
      axios
        .put(
          `${this.getOrganization}/employee/claim/workflow/${this.$ApiVersion}/assign`,
          data,
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode === 200) {
              this.loading = false;
              this.create_success = response.data.StatusMessage;
              this.getEmployeeClaimInfo(this.getCurrentEmployeeId);
              setTimeout(() => {
                this.create_success = null;
              }, 3000);
            } else {
              this.create_error = response.data.StatusMessage;
              this.getEmployeeClaimInfo(this.getCurrentEmployeeId);
              this.loading = false;
              setTimeout(() => {
                this.create_error = null;
              }, 3000);
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
            setTimeout(() => {
              this.create_error = null;
            }, 2500);
          }
        );
    },

    deleteClaimWorkflowAssignedToEmployee(claimTypeId) {
      const data = {
        EmployeeId: this.getCurrentEmployeeId,
        EmployeeLeaveTypeId: claimTypeId,
      };
      this.loading = true;
      axios
        .delete(
          `${this.getOrganization}/employee/claim/type/${this.$ApiVersion}/delete`,
          {
            headers: {
              Authorization: `Bearer ${this.getToken}`,
              "Content-Type": "application/json",
            },
            data,
          }
        )
        .then(
          (response) => {
            if (response.data.StatusCode === 200) {
              this.loading = false;
              this.getEmployeeClaimInfo(this.getCurrentEmployeeId);
              this.delete_success = response.data.StatusMessage;
              setTimeout(() => {
                this.delete_success = null;
              }, 2500);
            } else {
              this.loading = false;
              this.delete_error = response.data.StatusMessage;
              this.getEmployeeClaimInfo(this.getCurrentEmployeeId);
            }
          },
          (error) => {
            this.loading = false;
            this.delete_error = error.message;
            setTimeout(() => {
              this.delete_error = null;
              this.getEmployeeClaimInfo(this.getCurrentEmployeeId);
            }, 2500);
          }
        );
    },
    // /{organization}/employee/claim/info/{employeeId}/v1/request
    getEmployeeClaimInfo() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/claim/info/${this.getCurrentEmployeeId}/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode === 200) {
              this.get_success = response.data.StatusMessage;
              this.myClaimWorkflows = response.data.Data;
              this.selectedClaimWorkflow =
                response.data.Data.ClaimWorkflowGroup;
              this.loading = false;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
            setTimeout(() => {
              this.showEditError = false;
            }, 2000);
          }
        );
    },

    assignEmployeeClaimWorkflow() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      const workflow = {
        EmployeeId: this.getCurrentEmployeeId,
        ClaimWorkflowGroupId: this.selectedClaimWorkflow,
      };
      axios
        .put(
          `${this.getOrganization}/employee/claim/workflow/v1/assign`,
          workflow,
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode === 200) {
              this.loading = false;
              this.edit_success = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_success = false;
              }, 2000);
            } else {
              this.edit_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
            setTimeout(() => {
              this.showEditError = false;
            }, 2000);
          }
        );
    },
  },

  created() {
    this.getLeaveTypes();
    this.getEmployeeClaimInfo();
    this.getClaimWorkflows();
  },
};
</script>
